import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

export interface SpinnerProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  size?: "small" | "large";
}

export const Spinner: FC<SpinnerProps> = ({ size = "small", className }) => {
  return (
    <div
      className={clsx(
        "border-gray-300 animate-spin rounded-full border-4 border-t-primary",
        size === "small" && "w-6 h-6",
        size === "large" && "h-16 w-16",
        className
      )}
    />
  );
};
